const isBusinessWeChat = () => {
  var ua = navigator.userAgent.toLowerCase();
  return /wxwork/i.test(ua) && /MicroMessenger/i.test(ua);
};

export default isBusinessWeChat;
